/* ==========================================================================
   MX theme – mx-pc-builder.js   (sections/mx-pc-builder.liquid; needs mx-pc-builder-util.js first)
   Pick a product per step, keep a running total, and send the build to WhatsApp.
   State: { stepId: [{ v: variantId, q: qty }] }, kept in the page link (#build=v123x1.v456x2) so a build can be
   shared and reopened. Uses window.MXTheme (mx-global.js) for money, WhatsApp links, toasts and the cart.
   ========================================================================== */
(function () {
  'use strict';
  function boot() {
  if (customElements.get('mx-pc-builder')) return;

  var PAGE = 12; // products shown per step before "Show more"

  var U = window.MXPcb;
  var money = U.money, fill = U.fill, el = U.el, icon = U.icon;

  class MXPcBuilder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var d = this.dataset;
      this.L = {
        select: d.lSelect, selected: d.lSelected, remove: d.lRemove, sold: d.lSold, none: d.lNone, empty: d.lEmpty,
        noMatch: d.lNoMatch, items: d.lItems, missing: d.lMissing, qty: d.lQty, copied: d.lCopied, added: d.lAdded,
        error: d.lError, more: d.lShowMore
      };
      this.M = { intro: d.mIntro, total: d.mTotal, name: d.mName, city: d.mCity, note: d.mNote, link: d.mLink, links: d.mLinks === 'true' };
      this.require = d.require === 'true';
      this.steps = [];
      this.byVariant = {};
      var self = this;

      this.querySelectorAll('[data-step]').forEach(function (node, i) {
        var data = [];
        try { data = JSON.parse(node.querySelector('[data-step-data]').textContent || '[]'); } catch (e) { data = []; }
        data.forEach(function (p, order) {
          p.order = order;
          p.avail = p.v.some(function (v) { return v.a; });
          p.min = Math.min.apply(null, p.v.map(function (v) { return v.p; }));
          p.v.forEach(function (v) { self.byVariant[v.id] = { step: node.dataset.step, product: p, variant: v }; });
        });
        var step = {
          id: node.dataset.step, index: i, node: node, title: node.dataset.title,
          required: node.dataset.required === 'true', multi: node.dataset.multi === 'true',
          max: Math.max(1, parseInt(node.dataset.max, 10) || 1),
          products: data, query: '', sort: 'featured', shown: PAGE, skipped: false,
          grid: node.querySelector('[data-step-grid]'), more: node.querySelector('[data-step-more]'),
          head: node.querySelector('[data-step-toggle]'), body: node.querySelector('.mxpcb-step__body'),
          pick: node.querySelector('[data-step-pick]'), price: node.querySelector('[data-step-price]'),
          hint: node.querySelector('[data-step-pick]').textContent
        };
        self.steps.push(step);

        step.head.addEventListener('click', function () { self.toggle(step); });
        node.querySelector('[data-step-search]').addEventListener('input', function (e) { step.query = e.target.value.trim().toLowerCase(); step.shown = PAGE; self.renderStep(step); });
        node.querySelector('[data-step-sort]').addEventListener('change', function (e) { step.sort = e.target.value; self.renderStep(step); });
        step.more.addEventListener('click', function () { step.shown += PAGE; self.renderStep(step); });
        var skip = node.querySelector('[data-step-skip]');
        if (skip) skip.addEventListener('click', function () { self.state[step.id] = []; step.skipped = true; self.update(); self.next(step); });
        node.querySelector('[data-step-next]').addEventListener('click', function () { self.next(step); });
        step.grid.addEventListener('click', function (e) { self.onGridClick(step, e); });
        step.grid.addEventListener('change', function (e) {
          var sel = e.target.closest('[data-variant-select]');
          if (sel) self.onVariantChange(step, sel);
        });
      });

      this.state = {};
      this.steps.forEach(function (st) { self.state[st.id] = []; });
      this.readHash();

      this.list = this.querySelector('[data-sum-list]');
      this.totalEl = this.querySelector('[data-sum-total]');
      this.countEl = this.querySelector('[data-sum-count]');
      this.missingEl = this.querySelector('[data-missing]');
      this.wa = this.querySelector('[data-wa]');
      this.cartBtn = this.querySelector('[data-cart-add]');
      this.resetBtn = this.querySelector('[data-reset]');
      this.shareBtn = this.querySelector('[data-share]');
      this.live = this.querySelector('[data-live]');
      this.bar = this.querySelector('[data-bar]');
      this.fields = { name: this.querySelector('[data-f-name]'), city: this.querySelector('[data-f-city]'), note: this.querySelector('[data-f-note]') };

      Object.keys(this.fields).forEach(function (k) {
        if (self.fields[k]) self.fields[k].addEventListener('input', function () { self.updateWa(); });
      });
      if (this.wa) this.wa.addEventListener('click', function (e) {
        if (self.wa.getAttribute('aria-disabled') === 'true') {
          e.preventDefault();
          if (self.missingEl && !self.missingEl.hidden) self.missingEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
          var first = self.missingSteps()[0];
          if (first) self.open(first, true);
        }
      });
      if (this.cartBtn) this.cartBtn.addEventListener('click', function () { self.addToCart(); });
      if (this.resetBtn) this.resetBtn.addEventListener('click', function () {
        self.steps.forEach(function (st) { self.state[st.id] = []; st.skipped = false; });
        self.update();
        self.open(self.steps[0], true);
      });
      if (this.shareBtn) this.shareBtn.addEventListener('click', function () { self.copyLink(); });

      if (this.bar && 'IntersectionObserver' in window) {
        var card = this.querySelector('.mxpcb-sum__card');
        this._io = new IntersectionObserver(function (entries) {
          self._sumVisible = entries[0].isIntersecting;
          self.updateBar();
        });
        this._io.observe(card);
      }

      this.steps.forEach(function (st) { self.renderStep(st); });
      this.update(true);
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      document.documentElement.classList.remove('mxpcb-bar-on');
    }

    /* ---------------- steps */
    toggle(step) {
      var open = step.head.getAttribute('aria-expanded') === 'true';
      if (open) this.close(step); else this.open(step, false);
    }
    open(step, scroll) {
      step.head.setAttribute('aria-expanded', 'true');
      step.body.hidden = false;
      if (scroll) {
        var top = step.node.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).scrollPaddingTop, 10) || 96);
        window.scrollTo({ top: top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
    close(step) { step.head.setAttribute('aria-expanded', 'false'); step.body.hidden = true; }
    next(step) {
      this.close(step);
      var nxt = this.steps[step.index + 1];
      if (nxt) { this.open(nxt, true); nxt.head.focus({ preventScroll: true }); }
      else {
        var sum = this.querySelector('.mxpcb-sum');
        if (sum) sum.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    visible(step) {
      var q = step.query;
      var list = step.products.filter(function (p) {
        if (!q) return true;
        return (p.t + ' ' + p.b + ' ' + p.c).toLowerCase().indexOf(q) !== -1;
      });
      list.sort(function (a, b) {
        if (a.avail !== b.avail) return a.avail ? -1 : 1;
        if (step.sort === 'price-asc') return a.min - b.min;
        if (step.sort === 'price-desc') return b.min - a.min;
        return a.order - b.order;
      });
      return list;
    }

    chosen(step, productId) {
      var picks = this.state[step.id];
      for (var i = 0; i < picks.length; i++) {
        var info = this.byVariant[picks[i].v];
        if (info && info.product.id === productId) return picks[i];
      }
      return null;
    }

    renderStep(step) {
      var self = this;
      var list = this.visible(step);
      var grid = step.grid;
      grid.textContent = '';
      if (!step.products.length || !list.length) {
        var li = el('li', 'mxpcb-grid__empty', step.products.length ? this.L.noMatch : this.L.empty);
        grid.appendChild(li);
      }
      list.slice(0, step.shown).forEach(function (p) { grid.appendChild(self.card(step, p)); });
      var rest = list.length - step.shown;
      step.more.hidden = rest <= 0;
      if (rest > 0) step.more.textContent = fill(this.L.more, { count: rest });
    }

    card(step, p) {
      var pick = this.chosen(step, p.id);
      var variant = pick ? this.byVariant[pick.v].variant : (p.v.filter(function (v) { return v.a; })[0] || p.v[0]);
      var li = el('li', 'mxpcb-card' + (pick ? ' is-selected' : '') + (p.avail ? '' : ' is-sold'));
      li.dataset.product = p.id;

      var media = el('div', 'mxpcb-card__media');
      if (p.i) {
        var img = document.createElement('img');
        img.src = p.i; img.alt = ''; img.loading = 'lazy'; img.width = 160; img.height = 160;
        media.appendChild(img);
      }
      li.appendChild(media);

      var body = el('div', 'mxpcb-card__body');
      if (p.b) body.appendChild(el('span', 'mxpcb-card__brand', p.b));
      var a = el('a', 'mxpcb-card__title', p.t);
      a.href = p.u; a.target = '_blank'; a.rel = 'noopener';
      body.appendChild(a);

      if (p.v.length > 1) {
        var sel = el('select', 'mxpcb-card__variant');
        sel.setAttribute('data-variant-select', '');
        sel.setAttribute('aria-label', p.t);
        p.v.forEach(function (v) {
          var o = el('option', null, v.t + (v.a ? '' : ' – ' + this.L.sold));
          o.value = v.id; o.disabled = !v.a;
          if (v.id === variant.id) o.selected = true;
          sel.appendChild(o);
        }, this);
        body.appendChild(sel);
      }

      var price = el('div', 'mxpcb-card__price mx-num');
      price.appendChild(el('strong', null, money(variant.p)));
      if (variant.cp > variant.p) price.appendChild(el('s', null, money(variant.cp)));
      body.appendChild(price);
      li.appendChild(body);

      var act = el('div', 'mxpcb-card__act');
      if (!p.avail) {
        act.appendChild(el('span', 'mxpcb-card__sold', this.L.sold));
      } else if (pick) {
        if (step.max > 1) {
          var qty = el('div', 'mxpcb-qty');
          qty.setAttribute('role', 'group');
          qty.setAttribute('aria-label', this.L.qty + ': ' + p.t);
          qty.innerHTML = '<button type="button" data-qty="-1" aria-label="-">' + icon('minus') + '</button><span class="mx-num">' + pick.q + '</span><button type="button" data-qty="1" aria-label="+"' + (pick.q >= step.max ? ' disabled' : '') + '>' + icon('plus') + '</button>';
          act.appendChild(qty);
        }
        var rm = el('button', 'mxpcb-card__btn is-on');
        rm.type = 'button';
        rm.setAttribute('data-toggle', '');
        rm.setAttribute('aria-pressed', 'true');
        rm.innerHTML = icon('check') + '<span>' + this.L.selected + '</span>';
        rm.title = this.L.remove;
        act.appendChild(rm);
      } else {
        var add = el('button', 'mxpcb-card__btn');
        add.type = 'button';
        add.setAttribute('data-toggle', '');
        add.setAttribute('aria-pressed', 'false');
        add.innerHTML = icon('plus') + '<span>' + this.L.select + '</span>';
        act.appendChild(add);
      }
      li.appendChild(act);
      return li;
    }

    currentVariant(card, p) {
      var sel = card.querySelector('[data-variant-select]');
      var id = sel ? parseInt(sel.value, 10) : null;
      return p.v.filter(function (v) { return id ? v.id === id : v.a; })[0] || p.v[0];
    }

    onGridClick(step, e) {
      var card = e.target.closest('.mxpcb-card');
      if (!card) return;
      var p = step.products.filter(function (x) { return String(x.id) === card.dataset.product; })[0];
      if (!p || !p.avail) return;
      var picks = this.state[step.id];
      var pick = this.chosen(step, p.id);
      var qbtn = e.target.closest('[data-qty]');
      if (qbtn && pick) {
        pick.q = Math.min(step.max, Math.max(0, pick.q + parseInt(qbtn.dataset.qty, 10)));
        if (pick.q === 0) picks.splice(picks.indexOf(pick), 1);
        this.update();
        return;
      }
      if (!e.target.closest('[data-toggle]')) return;
      if (pick) {
        picks.splice(picks.indexOf(pick), 1);
        this.announce(this.L.remove + ': ' + p.t);
      } else {
        var v = this.currentVariant(card, p);
        if (!v.a) return;
        if (!step.multi) picks.length = 0;
        picks.push({ v: v.id, q: 1 });
        step.skipped = false;
        this.announce(this.L.selected + ': ' + p.t);
      }
      this.update();
      var btn = step.grid.querySelector('[data-product="' + p.id + '"] [data-toggle]');
      if (btn) btn.focus();
    }

    onVariantChange(step, sel) {
      var card = sel.closest('.mxpcb-card');
      var p = step.products.filter(function (x) { return String(x.id) === card.dataset.product; })[0];
      var pick = this.chosen(step, p.id);
      var v = p.v.filter(function (x) { return String(x.id) === sel.value; })[0];
      if (pick && v && v.a) { pick.v = v.id; this.update(); }
      else this.renderStep(step);
    }

    announce(msg) {
      if (!this.live) return;
      this.live.textContent = '';
      var live = this.live;
      setTimeout(function () { live.textContent = msg; }, 30);
    }
  }

  Object.keys(U.methods).forEach(function (k) { MXPcBuilder.prototype[k] = U.methods[k]; });
  customElements.define('mx-pc-builder', MXPcBuilder);
  }
  // mx-pc-builder-util.js may load before or after this file
  if (window.MXPcb) boot(); else window.addEventListener('mxpcb:util', boot, { once: true });
})();